import React from "react";
import { Container, Modal, Row, Card, Col, Input, Button } from "reactstrap";
import TableComponent from "../../../components/Common/TableComponent";
// import Pagination from "react-js-pagination";
import { getCities, updateCityStatus, removeCity } from "../../../services/cityService";
import AddCity from "./AddCity";
import { notifyError, notifySuccess } from "../../../utils/utils";
import PaginationComponent from "../../../components/Common/Pagination";
import Switch from "react-switch";


class City extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            sort: "city_id",
            limit: 10,
            page: 0,
            asc:false,
            search: "",
            city: {},
            cities:[],
            total_count:0,
            isEditing: false,
            modelOpen:false,
            loading: false
        };
    
        this.changePage = this.changePage.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.deleteCity = this.deleteCity.bind(this);

    };


    toggleModal(value, edit) {
        this.setState({
            modelOpen: !this.state.modelOpen,
            city: this.state.modelOpen ? {} : value,
            isEditing: value ? true : false
        })
    }

    changePage(pageNumber) {

        this.setState({ page: pageNumber });

        const req = {
            offset: pageNumber,
            limit: this.state.limit,
            search: this.state.search,
            sort: this.state.sort,
            asc: this.state.asc
        };

        this.setState({ loading: true });
        getCities(req)
        .then(response => {
            this.setState({ loading: false });
            const { data } = response;

            if(data.status)
            {
                this.setState({
                    cities: data.cities,
                    total_count: data.totalCount
                });
            } else {
                notifyError(data.message);
                this.setState({
                    cities: [],
                    total_count: 0
                });
            }

        })
    }

    changeStatus(id, status) {
        updateCityStatus(id, {is_active: status})
        .then(response => {
            const { data } = response;
            if(data.status) {
                notifySuccess(data.message);
                setTimeout(() => this.changePage(0) , 2000);
            } else {
                notifyError(data.message);
            }   
        });
        
    }

    
    deleteCity(id) {
        removeCity(id)
        .then(res => {
            const { data } = res;
            if(data.status){
                notifySuccess(data.message);
                this.changePage(this.state.page);
            }  else {
                notifyError(data.message);
            }
        });   
    }

    applySort = key => {
        if(this.state.sort === key)
        {
            this.setState({asc: !this.state.asc}, () => this.changePage(0));
        } else {
            this.setState({sort: key, asc: true}, () => this.changePage(0));
        }
     }
    
    componentDidMount() {
        this.changePage(0);
    }


    render() {

        
        const columns = [
            // {
            //     Header: "No.",
            //     accessor: "_id",
            //     Cell: ({row}) => (this.state.page * this.state.limit) + (row.index + 1)
            // },
            {
                Header: () => "City Id" ,
                accessor: "city_id",
                sortable : true,
                Cell: ({row}) => <span>{row.original.city_id}</span>,
            },
            {
                Header: "City",
                accessor: "name",
                sortable: true,
                Cell: ({row}) => {
                    return (
                        <>
                            <span>{row.original.name}</span> 
                        </>
                    )
                }
            },
            {
                Header: "Active",
                accessor: "active",
                // sortable: true,
                Cell: ({row}) => 
                    <>  
                        <Switch
                            uncheckedIcon={<span>&#160;</span>}
                            checkedIcon={<span>&#160;</span>}
                            // onColor="#626ed4"
                            onColor="#02a499"
							offColor="#ec4561"
                            onChange={() => this.changeStatus(row.original.city_id, !row.original.is_active)}
                            checked={row.original.is_active}
                            className="mr-1 mt-1"
                        />
                    </>
                
            },
            {
                Header: "Action",
                Cell: ({row}) => 
                    <>
                        <Button 
                            onClick={e => { 
                                this.toggleModal(row.original);
                            }} 
                            className="mr-3 bg-white no-border"
                        >
                            <i className="mdi mdi-pencil text-primary font-size-18"></i>
                        </Button>
                     
                        {/* <Button to={`#`} onClick={() => this.deleteCity(row.original.city_id)} className="mr-3 bg-white no-border " id="edit6"><i className="fa fa-trash text-danger font-size-18"></i></Button> */}
                      
                    </>
            }
        ];

        return(
            <React.Fragment>
                <div className="page-content">

<Container fluid>
      
    <Card>
        <h3 className="p-3"> City </h3>
        <hr />
        <Row className="p-2">
            <Col lg={6} md={6} sn={6} xs={6}>
                <Button
                    color="info"
                    className="mr-3 no-border text-white"
                    onClick={() => {
                        this.setState({
                            modelOpen: true,
                            isEditing: false
                        });
                    }}
                >
                 <i className="fas fa-plus"></i>   Add 
                </Button>
            </Col>

            <Col lg={6} md={6} sn={6} xs={6}>
                <div className="form-inline float-md-right">
                    <div className="search-box ml-2">
                        <div className="position-relative">
                            <Input
                                onChange={e => {                                                        
                                    this.setState(
                                        { search: e.target.value },
                                        () => this.changePage(0)
                                      );
                                }}
                                bsSize="lg"
                                type="text"
                                name="search"
                                value={this.state.search}
                                className="form-control rounded"
                                placeholder="city"
                            />
                            <i className="mdi mdi-magnify search-icon"></i>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>

        <div className="table-responsive mt-2 p-1" style={{"height": "1000px"}}>
            <TableComponent
                columns={columns}
                data={this.state.cities}
                sort={this.state.sort}
                asc={this.state.asc}
                applySort={this.applySort}
                loading={this.state.loading}
            />
        </div>
        <div style={{"position":"absolute","bottom":"10px","width":"100%","zIndex":"99999", "backgroundColor": "white"}}>
        <PaginationComponent
            total_count={this.state.total_count}
            page={this.state.page}
            limit={this.state.limit}
            changePage={this.changePage}
            changeFilter={e => {
                this.setState({ limit: e.target.value }, () => this.changePage(0));
            }}
        />
        </div>
    </Card>
</Container>
</div>

<Modal
isOpen={this.state.modelOpen}
toggle={() => this.setState({ modelOpen: false})}
centered={true}
backdrop="static"
>
<AddCity
    isEditing={this.state.isEditing}
    city={this.state.city}
    toggle={() => this.toggleModal({})}
    reload={() => this.changePage(0)}
/>
</Modal>

            </React.Fragment>
        )
    }
}


export default City;